import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

export function MegaMenuPanel({ data, isOpen }) {
  if (!data) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="absolute top-full left-0 right-0 z-50"
          data-testid="mega-menu-panel"
        >
          <div className="h-3" />

          <div className="bg-[#1A120B] border border-[#C9922A]/15 shadow-[0_20px_60px_rgba(0,0,0,0.5)] rounded-b-2xl overflow-hidden">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-12 min-h-[280px]">
                <div className="col-span-4 relative overflow-hidden">
                  <img src={data.image} alt="" className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#1A120B]/60" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1A120B]/80 via-transparent to-transparent" />
                  <div className="absolute bottom-6 left-6 right-6">
                    <Link
                      to={data.cta.path}
                      className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#C9922A] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[#B8831F] transition-colors shadow-[0_4px_20px_rgba(201,146,42,0.3)]"
                      data-testid="mega-menu-cta"
                    >
                      {data.cta.label}
                      <ArrowRight className="w-3.5 h-3.5" />
                    </Link>
                  </div>
                </div>

                <div className="col-span-8 p-8 pl-10">
                  <div className="grid gap-1">
                    {data.items.map((item, i) => (
                      <Link
                        key={i}
                        to={item.path}
                        className="group flex items-start gap-4 p-4 -mx-4 rounded-xl hover:bg-white/[0.04] transition-all duration-200"
                        data-testid={`mega-item-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                      >
                        <div className="w-8 h-8 rounded-lg bg-[#C9922A]/10 border border-[#C9922A]/20 flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-[#C9922A]/20 transition-colors">
                          <span className="font-mono text-[10px] font-bold text-[#C9922A]">{String(i + 1).padStart(2, "0")}</span>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <span className="font-semibold text-white group-hover:text-[#C9922A] transition-colors text-sm">{item.label}</span>
                            <ArrowRight className="w-3 h-3 text-[#C9922A] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200" />
                          </div>
                          <span className="text-white/35 text-xs leading-relaxed mt-0.5 block group-hover:text-white/50 transition-colors">{item.desc}</span>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="h-px bg-gradient-to-r from-transparent via-[#C9922A]/30 to-transparent" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
